import React, { useEffect, useState } from "react";
import Select, { components } from 'react-select';
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi'
import { compactMultiSelectComponents } from './compactMultiSelect';
import { FacilityDropdown } from "src/context/actions/Facilitydropdown";
import { reactLocalStorage } from "reactjs-localstorage";
import { useSelector } from "react-redux";
import { setUserData } from "src/reducer/userData/userSlice";
import { useDispatch } from "react-redux";


const Facilitydropdown = ({ client, search, setSearch, compact = false }) => {

    const [IsCorresCategory, setIsCorresCategory] = useState(false);
    const [facilities, setFacilities] = useState([])
    const user_type = reactLocalStorage.get('user_type');
    const dispatchUser = useDispatch(); 
    const currentFacility = useSelector((state) => state.user.facility);

    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props}>
                {search && search?.facility_name?.length > 1 ? (
                    <TbGridDots style={{ fontSize: "1.5em" }} />
                ) : (
                    <HiChevronDown style={{ fontSize: "1.5em" }} />
                )}
            </components.DropdownIndicator>
        );
    };

    useEffect(() => {
    let apiTimeoout =  setTimeout(() => {
            if (client && client.length > 0) {
                FacilityDropdown(client)((response) => {

                    if (response && response.status) {
                        let apiResponse = response?.data?.data?.facilities
                            const selectedFacilitiesIds = apiResponse?.flatMap(i=>i?.facilities)?.map(ite=>ite.value)
                            
                            const filterFacility = search?.facility_name?.filter(i => selectedFacilitiesIds?.includes(i))
                            setSearch({ ...search,facility_name: filterFacility })              
                            setFacilities(
                                apiResponse?.map((result) => {
                                    return { options: result?.facilities, label: result?.client };
                                })
                            );

                            const newFacility = apiResponse?.flatMap(i => i?.facilities);
                            if(user_type === "facility" && newFacility?.length === 1){
                                setSearch({ ...search, facility_name:[ newFacility?.[0]?.value] }) 
                                dispatchUser(setUserData({ facility: newFacility ,isfacilityFreeze:true}));
                            }

                           
                    }
                });
            } else{
                setFacilities([]); 
            }  
        }, 1000);
        return()=>{
          clearTimeout(apiTimeoout)
        }
       
    }, [client]);

    return (
        <>
<div style={{marginRight:".5rem"}} >
            <Select
                isMulti
                tabSelectsValue={false} 
                closeMenuOnSelect={false}
                components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="corres_category" />, ...(compact ? compactMultiSelectComponents : {}) }}
                hideSelectedOptions={!compact}
                options={facilities}
                isDisabled={(user_type === "facility" && currentFacility?.length > 0) ? true : false} // USERTYPE 4 IS FACILITY
                value={facilities?.flatMap(i=>i?.options)?.filter(j=>search?.facility_name?.includes(j?.value))}
                aria-placeholder="Correspondence Category"
                placeholder="Facility Name"
                classNamePrefix='Status'
                isClearable
                onChange={(e) => {setSearch({ ...search,facility_name: e.map(i=>i.value) }) }}
                onFocus={() => setIsCorresCategory(true)}
                onBlur={() => setIsCorresCategory(false)}
                styles={{
                    container: (styles, state) => ({
                        ...styles,
                        borderRadius: "9px",
                        width: "230px"
                    }),
                    placeholder: styles => ({
                        ...styles,
                        fontSize: '0.9em',
                        fontWeight: 400,
                        paddingBottom: '0px'
                    }),
                    control: (styles, state) => ({
                        ...styles,
                        backgroundColor: "transparent",
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderTop: 'none',
                        borderBottomColor: 'black',
                        boxShadow: "none",
                        borderRadius: "0px",
                    }),
                    indicatorSeparator: styles => ({
                        ...styles, width: "0px",
                        minHeight: "20px"
                    }),
                    valueContainer: (styles, state) => ({
                        ...styles,
                        maxHeight: IsCorresCategory ? "auto" : "30px",
                    }),
                    menu: (styles) => ({
                        ...styles,
                        zIndex: 9999,
                    }),
                }}
            />
</div>
        </>
    )
}
export default React.memo(Facilitydropdown)